import React, { useState } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { StudentPathDto } from "../../api-clients/api";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import LabelFieldValue from "../Shared/LabelFieldValue";
import { dateToString, numberToMad } from "../../helper";
import { green } from "@material-ui/core/colors";
import SchoolIcon from "@material-ui/icons/School";
import { ContextualMenu, Panel } from "@fluentui/react";
import UpdateStudentPath from "../CRUD/UpdateStudentPath";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useTranslation } from "react-i18next";
import { useRole } from "../../hooks/useRole";

interface IProps {
  historyPath: StudentPathDto[] | null;
  historyPathLoading: boolean;
}
export default function CardStudentPath({
  historyPath,
  historyPathLoading,
}: IProps) {
  const { t } = useTranslation();
  const { isAdmin } = useRole();
  const menuItemRef = React.useRef(null);
  const [showMenuContext, setShowMenuContext] = useState<boolean>(false);
  const [updateStudentPath, setUpdateStudentPath] = useState<boolean>(false);

  return (
    <>
      <Card>
        <CardHeader
          title={t("studentPath.schoolPath")}
          avatar={
            <Avatar style={{ backgroundColor: green[200] }}>
              <SchoolIcon />
            </Avatar>
          }
          action={
            isAdmin && (
              <IconButton
                aria-label={t("common.menu")}
                ref={menuItemRef}
                onClick={() => setShowMenuContext(true)}
              >
                <MoreVertIcon />
              </IconButton>
            )
          }
        />
        <ContextualMenu
          items={[
            {
              key: "editStudentPath",
              text: t("studentPath.editSchoolPath"),
              iconProps: { iconName: "PageEdit" },
              onClick: () => setUpdateStudentPath(true),
            },
          ]}
          hidden={!showMenuContext}
          target={menuItemRef}
          onItemClick={() => setShowMenuContext(false)}
          onDismiss={() => setShowMenuContext(false)}
        />
        <CardContent>
          {!historyPathLoading ? (
            historyPath && historyPath.length > 0 ? (
              historyPath.map((hp) => (
                <div key={hp.studentPathId}>
                  <Grid container>
                    {hp.endDate != null && hp.endDate <= new Date() && (
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          color="secondary"
                          gutterBottom
                        >
                          {t("common.expired")}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("studentPath.schoolYear")}
                        value={
                          hp.startDate?.getFullYear() +
                          "/" +
                          hp.endDate?.getFullYear()
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("studentPath.classroom")}
                        value={hp.classroomName}
                        href={`/classroom/${hp.classroomId}`}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("services.startDate")}
                        value={dateToString(hp.startDate)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("services.endDate")}
                        value={dateToString(hp.endDate)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("studentPath.enrollmentFeesLabel")}
                        value={numberToMad(hp.inscriptionFees)}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <LabelFieldValue
                        label={t("studentPath.tuitionFeesLabel")}
                        value={numberToMad(hp.monthlyFees)}
                      />
                    </Grid>
                  </Grid>
                </div>
              ))
            ) : (
              <NoResult />
            )
          ) : (
            <Loading />
          )}
        </CardContent>
      </Card>

      <Panel
        isBlocking={true}
        headerText={t("studentPath.editSchoolPath")}
        isOpen={isAdmin && updateStudentPath}
        onDismiss={() => setUpdateStudentPath(false)}
        closeButtonAriaLabel={t("common.close")}
      >
        {historyPath != null && historyPath.length > 0 && (
          <UpdateStudentPath
            studentPath={historyPath[0]}
            handleClose={() => setUpdateStudentPath(false)}
          />
        )}
      </Panel>
    </>
  );
}
